import { ContentLibraryTemplateParams } from 'features/content-library/types';

export const replaceUrlParams = (url: string, params: ContentLibraryTemplateParams) => {
  if (params && Object.keys(params)) {
    return url.replace(/{(\w+)}/g, (_, key) => params[key] || '');
  }

  return url;
};

export const formatUrlParams = (url: string, method: 'encode' | 'decode') => {
  const [baseUrl, queryString] = url.split('?');
  if (!queryString) {
    return url;
  }

  const encodedParams = queryString
    .split('&')
    .map((param) => {
      const [key, value] = param.split('=');
      return `${key}=${method === 'encode' ? encodeURIComponent(value) : decodeURIComponent(value)}`;
    })
    .join('&');

  return `${baseUrl}?${encodedParams}`;
};

export const rewriteGoogleEmbedUrl = (url: string): string => {
  const publishedSlides = url.match(/^https?:\/\/docs\.google\.com\/presentation\/d\/e\/([\w-]+)/i);
  if (publishedSlides) {
    return `https://docs.google.com/presentation/d/e/${publishedSlides[1]}/embed?start=false&loop=false&delayms=3000`;
  }

  // Docs/Sheets /edit links stay untouched — /preview is read-only and breaks live collaboration.
  const match = url.match(/^https?:\/\/docs\.google\.com\/presentation\/d\/(?!e\/)([\w-]+)/i);
  if (!match) {
    return url;
  }

  const [, id] = match;

  return `https://docs.google.com/presentation/d/${id}/embed?start=false&loop=false&delayms=3000`;
};
